import { connect } from 'react-redux'

import DirectoriesContentComponent from '../components/directories_content_component'
import { fetchMoreData, fetchInitialData } from '../actions'

const mapStateToProps = (state) => {
  const shouldLoadData = !!state.misc.fetchInitialDataURL

  return {
    viewType: state.filters.viewType,
    dataIsLoading: !!state.misc.dataIsLoading,
    filteredDataIsLoading: !!state.misc.filteredDataIsLoading,
    showPortals: state.misc.showPortals,
    shouldLoadData: shouldLoadData,
    tourId: state.misc.tourId,
    noMoreData: state.misc.noMoreData,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: (tourId) => dispatch(fetchInitialData(tourId)),
  fetchMoreData: (tourId) => dispatch(fetchMoreData(tourId)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DirectoriesContentComponent)
